import { render, staticRenderFns } from "./ButtonsContacts.vue?vue&type=template&id=5483b43e&scoped=true&"
import script from "./ButtonsContacts.vue?vue&type=script&lang=js&"
export * from "./ButtonsContacts.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsContacts.vue?vue&type=style&index=0&id=5483b43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483b43e",
  null
  
)

export default component.exports